import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';

interface ClearDataDialogProps {
  open: boolean;
  subreddit: string | null;
  isClearing: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function ClearDataDialog({
  open,
  subreddit,
  isClearing,
  onClose,
  onConfirm,
}: ClearDataDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Are you sure?</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          Clear flair sheet for /r/{subreddit}
        </Typography>
        <Typography>
          This will delete ALL flair structure and sheet data for this subreddit.
        </Typography>
        <Typography sx={{ mt: 2, color: 'error.main', fontWeight: 'bold' }}>
          This will permanently delete:
        </Typography>
        <ul>
          <li>All master_sheet entries</li>
          <li>All classes</li>
          <li>All families</li>
          <li>All genuses</li>
          <li>All flairs</li>
          <li>All images</li>
        </ul>
        <Typography sx={{ mt: 2, color: 'error.main' }}>
          This action cannot be undone. Make sure you have exported your data first if needed.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained" disabled={isClearing}>
          {isClearing ? 'Clearing...' : 'Yes, Clear Flair Sheet'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
